import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceRequestList from './ServiceRequestList'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'service-order/list',
    name:
      'serviceRequest.request.list',
    component: ServiceRequestList,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
